(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_header-menu"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function(e) {
    const link = e.target.closest('.menu-list__link[aria-haspopup="true"]');
    if (link) {
      e.stopImmediatePropagation();
      window.location.href = link.href;
    }
  }, true);
  } catch(e) { console.error(e); }
})();

})();
